import { Component } from '@angular/core';
import { EmailAccount } from './email-account.model';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { ClientsService } from '../../../../services/clients/clients.service';
import { SuperClass } from '../../../../superclass/SuperClass';
import { WsService } from '../../../../services/websocket/WsService';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-analytics-email-accounts',
  templateUrl: './email-accounts.component.html',
  styleUrls: ['./email-accounts.component.css'],
})
export class AnalyticsEmailAccountsComponent extends SuperClass {
  selectedRow: EmailAccount;
  newAccount: EmailAccount;

  selectedRowForm: FormGroup;
  newAccountForm: FormGroup;

  emailForCheck: any;
  display = false;
  accounts: EmailAccount[];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Accounts' },
      {
        label: 'Email Accounts',
        routerLink: [
          { outlets: { sub: [RouterConst.ANALYTICS_EMAIL_ACCOUNTS] } },
        ],
      },
    ]);
    this.newAccount = new EmailAccount();
  }

  reloadData() {
    this.http_getAllAccounts('email', (response: any) => {
      this.accounts = response.payload;
    });

    this.selectedRowForm = this.fb.group({
      name: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      smtpHost: new FormControl('', Validators.required),
      smtpPort: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(60000),
        ]),
      ),
      smtpAuthMechanisms: new FormControl('', Validators.required),
    });

    this.newAccountForm = this.fb.group({
      name: new FormControl('', Validators.required),
      account: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      smtpHost: new FormControl('', Validators.required),
      smtpPort: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(60000),
        ]),
      ),
      smtpAuthMechanisms: new FormControl('', Validators.required),
    });
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  selectRow(e) {
    this.selectedRow = new EmailAccount(e.data);
  }

  saveAccount() {
    this.http_updateAccounts(this.selectedRow, 'email', (data: any) => {
      this.showSuccessMessage('Account has been updated');
      this.accounts = data.payload;
      this.unselectRow();
    });
  }

  addNewAccount() {
    this.display = true;
    this.newAccount = new EmailAccount();
  }

  checkEmail() {
    if (this.emailForCheck.length !== 0) {
      this.http_checkEmail(
        this.emailForCheck,
        this.selectedRow,
        (data: any) => {},
      );
    }
  }

  createNewAccount() {
    if (!this.newAccount.smtpAuth) {
      this.newAccount.smtpAuth = false;
    }
    if (!this.newAccount.smtpStarttlsEnable) {
      this.newAccount.smtpStarttlsEnable = false;
    }

    this.http_addAccount(this.newAccount, 'email', (data: any) => {
      this.showSuccessMessage('Account has been created');
      this.accounts = data.payload;
      this.unselectRow();
    });
    this.display = false;
  }

  deleteAccount() {
    this.http_deleteAccount(this.selectedRow, 'email', (data: any) => {
      this.showSuccessMessage('Account has been deleted');
      this.accounts = data.payload;
      this.unselectRow();
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/email-accounts/email-accounts.component.ts